<ion-card-header
  class="ion-no-padding"
  [class.variant-installer-dashboard]="variant() === 'installer-dashboard'"
>
  <ion-item-divider class="ion-no-padding">
    <h5 class="ion-padding-start">
      <ion-label color="dark" class="ion-margin-start">
        <ion-icon
          name="{{ icon() }}"
          item-left
          class="card-header-icon"
        ></ion-icon>
        <strong>{{ displayText() }}</strong>
        @if (subText()) {
          <small class="text-light-grey"> / {{ subText() }}</small>
        }
      </ion-label>
    </h5>
  </ion-item-divider>
</ion-card-header>
